var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-dialog', { staticClass: "reject-demand-dialog", attrs: { "width": "600px", "title": "需求驳回", "visible": _vm.dialog.visible }, on: { "update:visible": function updateVisible($event) {
        return _vm.$set(_vm.dialog, "visible", $event);
      } } }, [_c('dynamic-form', { ref: "form", attrs: { "form-config": _vm.formConfig, "form-value": _vm.form, "form-item-list": _vm.formItemList } }), _vm._v(" "), _c('div', { staticStyle: { "text-align": "right" } }, [_c('el-button', { attrs: { "type": "primary" }, on: { "click": function click($event) {
        _vm.dialog.visible = false;
      } } }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', { attrs: { "loading": _vm.loading, "type": "primary" }, on: { "click": _vm.handleSubmitReject } }, [_vm._v("提交")])], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };